import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// StrictMode disabled due to React 19 + React Router 7 compatibility issues
// Reference: https://github.com/remix-run/react-router/issues/14020
root.render(<App />);
